var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.can("read", "ratings")
        ? [
            _c(
              "vx-card",
              { staticClass: "mt-10", attrs: { id: "rating-to-perform" } },
              [_c("RatingToPerform", { attrs: { api: _vm.urlToperform } })],
              1
            ),
            _vm._v(" "),
            _c(
              "vx-card",
              { staticClass: "mt-10", attrs: { id: "rating-in-progress" } },
              [
                _c("RatingList", {
                  attrs: {
                    api: _vm.urlInprogress,
                    "type-name": _vm.projectNames.singular.toLowerCase(),
                    title: `${_vm.projectNames.plural} en cours`,
                    filter: "skill_review|=|0",
                    action: [
                      {
                        permission: (item) =>
                          _vm.canMulti(
                            "update",
                            "ratings",
                            item.employee.services.map((s) => s.id)
                          ),
                        href: (item) =>
                          `/rh/gestion/personnes/${item.employee.id}/bilans/poursuivre/${item.id}`,
                        tooltip: "Poursuivre",
                        icon: "icon-edit",
                      },
                    ],
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "vx-card",
              { staticClass: "mt-10", attrs: { id: "rating-to-validate" } },
              [
                _c("RatingList", {
                  attrs: {
                    api: _vm.urlTovalidate,
                    "type-name": _vm.projectNames.singular.toLowerCase(),
                    title: `${_vm.projectNames.plural}  en attente de validation`,
                    filter: "skill_review|=|0",
                    action: [
                      {
                        permission: (item) =>
                          _vm.canMulti(
                            "update",
                            "rating_validations",
                            item.employee.services.map((s) => s.id)
                          ),
                        href: (item) =>
                          `/rh/gestion/personnes/${item.employee.id}/bilans/valider/${item.id}`,
                        tooltip: `Valider le ${_vm.projectNames.singular.toLowerCase()}`,
                        icon: "icon-check-square",
                      },
                      {
                        permission: (item) => _vm.can("read", "ratings"),
                        href: (item) =>
                          `/rh/gestion/personnes/${item.employee.id}/bilans/consulter/${item.id}`,
                        tooltip: "Consulter",
                        icon: "icon-eye",
                      },
                    ],
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "vx-card",
              { staticClass: "mt-10", attrs: { id: "rating-validated" } },
              [
                _c("RatingList", {
                  attrs: {
                    api: _vm.urlValidated,
                    "type-name": _vm.projectNames.singular.toLowerCase(),
                    title: `${_vm.projectNames.plural} validés`,
                    filter: "skill_review|=|0",
                    action: [
                      {
                        permission: (item) =>
                          _vm.canMulti(
                            "read",
                            "ratings",
                            item.employee.services.map((s) => s.id)
                          ),
                        href: (item) =>
                          `/rh/gestion/personnes/${item.employee.id}/bilans/consulter/${item.id}`,
                        tooltip: "Consulter",
                        icon: "icon-eye",
                      },
                    ],
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.can("read", "skill_reviews")
        ? [
            _c(
              "vx-card",
              {
                staticClass: "mt-10",
                attrs: { id: "skillrating-in-progress" },
              },
              [
                _c("RatingList", {
                  attrs: {
                    api: _vm.urlInprogress,
                    "type-name": _vm.skillRatingNames.singular.toLowerCase(),
                    title: `${_vm.skillRatingNames.plural} en cours`,
                    filter: "skill_review|=|1",
                    action: [
                      {
                        permission: (item) =>
                          _vm.canMulti(
                            "update",
                            "skill_reviews",
                            item.employee.services.map((s) => s.id)
                          ),
                        href: (item) =>
                          `/rh/gestion/personnes/${item.employee.id}/bilans/poursuivre/${item.id}?skill-review=true`,
                        tooltip: "Poursuivre",
                        icon: "icon-edit",
                      },
                    ],
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "vx-card",
              {
                staticClass: "mt-10",
                attrs: { id: "skillrating-to-validate" },
              },
              [
                _c("RatingList", {
                  attrs: {
                    api: _vm.urlTovalidate,
                    "type-name": _vm.skillRatingNames.singular.toLowerCase(),
                    title: `${_vm.skillRatingNames.plural} en attente de validation`,
                    filter: "skill_review|=|1",
                    action: [
                      {
                        permission: (item) =>
                          _vm.canMulti(
                            "update",
                            "skill_review_validations",
                            item.employee.services.map((s) => s.id)
                          ),
                        href: (item) =>
                          `/rh/gestion/personnes/${item.employee.id}/bilans/valider/${item.id}?skill-review=true`,
                        tooltip: `Valider le ${_vm.skillRatingNames.singular.toLowerCase()}`,
                        icon: "icon-check-square",
                      },
                      {
                        permission: (item) => _vm.can("read", "skill_reviews"),
                        href: (item) =>
                          `/rh/gestion/personnes/${item.employee.id}/bilans/consulter/${item.id}?skill-review=true`,
                        tooltip: "Consulter",
                        icon: "icon-eye",
                      },
                    ],
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "vx-card",
              { staticClass: "mt-10", attrs: { id: "skillrating-validated" } },
              [
                _c("RatingList", {
                  attrs: {
                    api: _vm.urlValidated,
                    "type-name": _vm.skillRatingNames.singular.toLowerCase(),
                    title: `${_vm.skillRatingNames.plural} validés`,
                    filter: "skill_review|=|1",
                    action: [
                      {
                        permission: (item) =>
                          _vm.canMulti(
                            "read",
                            "skill_reviews",
                            item.employee.services.map((s) => s.id)
                          ),
                        href: (item) =>
                          `/rh/gestion/personnes/${item.employee.id}/bilans/consulter/${item.id}?skill-review=true`,
                        tooltip: "Consulter",
                        icon: "icon-eye",
                      },
                    ],
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.can("read", "ratings") || _vm.can("read", "skill_reviews")
        ? [
            _c(
              "vx-card",
              { staticClass: "mt-10", attrs: { id: "external-rating" } },
              [
                _c("RatingList", {
                  attrs: {
                    api: _vm.urlExternal,
                    "type-name": "transmission",
                    title: "Evaluations Portail transmises",
                    filter: "",
                    "hide-creator": true,
                    "force-loading": _vm.loadingExternalExport,
                    evaluation: true,
                    action: [
                      {
                        id: (item) => `export-personal-${item.id}`,
                        permission: (item) =>
                          _vm.canMulti(
                            "read",
                            "ratings",
                            item.employee.services.map((s) => s.id)
                          ) ||
                          _vm.canMulti(
                            "read",
                            "skill_reviews",
                            item.employee.services.map((s) => s.id)
                          ),
                        href: (item) => null,
                        tooltip: "Exporter",
                        icon: "icon-download",
                        on: (item) => {
                          return {
                            click: () => {
                              _vm.exportExternalRating = item.id
                              _vm.startExternalExport++
                            },
                          }
                        },
                      },
                    ],
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "vx-card",
              { staticClass: "mt-10", attrs: { id: "self-external-rating" } },
              [
                _c("RatingList", {
                  attrs: {
                    api: _vm.urlPersonal,
                    "type-name": "transmission",
                    title: "Auto-évaluations transmises",
                    filter: "",
                    "hide-creator": true,
                    "force-loading": _vm.loadingPersonalExport,
                    action: [
                      {
                        permission: (item) =>
                          _vm.canMulti(
                            "read",
                            "ratings",
                            item.employee.services.map((s) => s.id)
                          ) ||
                          _vm.canMulti(
                            "read",
                            "skill_reviews",
                            item.employee.services.map((s) => s.id)
                          ),
                        href: (item) => null,
                        tooltip: "Exporter",
                        icon: "icon-download",
                        on: (item) => {
                          return {
                            click: () => {
                              _vm.exportPersonalRating = item.id
                              _vm.startPersonalExport++
                            },
                          }
                        },
                      },
                    ],
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("PersonalEvalExport", {
        attrs: {
          "rating-id": _vm.exportPersonalRating,
          "start-export": _vm.startPersonalExport,
          "hide-button": true,
        },
        on: {
          loading: function ($event) {
            _vm.loadingPersonalExport = $event
          },
        },
      }),
      _vm._v(" "),
      _c("ExternalEvalExport", {
        attrs: {
          "rating-id": _vm.exportExternalRating,
          "start-export": _vm.startExternalExport,
          "hide-button": true,
        },
        on: {
          loading: function ($event) {
            _vm.loadingExternalExport = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }